import store, { RootState } from "../store";

export const fetchAuthenticated = async (
  input: RequestInfo,
  init: RequestInit
): Promise<Response> => {
  const state: RootState = store.getState();
  const accessToken = state.user.accessToken;
  const companyId = state.company.data.company.id;
  if (init.headers === undefined) {
    init.headers = {
      Authorization: `Bearer ${accessToken}`,
    };
    if (companyId !== undefined) {
      (init.headers as Record<string, string>)["X-Company-ID"] =
        companyId.toString();
    }
  } else {
    let headers = init.headers as Record<string, string>;
    headers.Authorization = `Bearer ${accessToken}`;
    if (companyId !== undefined) {
      headers["X-Company-ID"] = companyId.toString();
    }
    init.headers = headers;
  }
  return fetch(input, init);
};
